var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3" } },
            [
              _c("v-text-field", {
                attrs: { label: "Name", "error-messages": _vm.errors.name },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3" } },
            [
              _c("v-text-field", {
                attrs: { label: "Purok", "error-messages": _vm.errors.purok },
                model: {
                  value: _vm.purok,
                  callback: function($$v) {
                    _vm.purok = $$v
                  },
                  expression: "purok"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3" } },
            [
              _c("v-text-field", {
                attrs: { label: "Brgy", "error-messages": _vm.errors.brgy },
                model: {
                  value: _vm.brgy,
                  callback: function($$v) {
                    _vm.brgy = $$v
                  },
                  expression: "brgy"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "City/Municipality",
                  "error-messages": _vm.errors.city
                },
                model: {
                  value: _vm.city,
                  callback: function($$v) {
                    _vm.city = $$v
                  },
                  expression: "city"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Province",
                  "error-messages": _vm.errors.province
                },
                model: {
                  value: _vm.province,
                  callback: function($$v) {
                    _vm.province = $$v
                  },
                  expression: "province"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Contact No 1",
                  "error-messages": _vm.errors.contactno1
                },
                model: {
                  value: _vm.contactno1,
                  callback: function($$v) {
                    _vm.contactno1 = $$v
                  },
                  expression: "contactno1"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Contact No 2",
                  "error-messages": _vm.errors.contactno2
                },
                model: {
                  value: _vm.contactno2,
                  callback: function($$v) {
                    _vm.contactno2 = $$v
                  },
                  expression: "contactno2"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }